// @ts-check
import {
  Box,
  DeleteIcon,
  DownloadIcon,
  Link,
  Menu,
  MenuButton,
  MenuItem,
  MenuLink,
  MenuList,
  TableCell,
  TableRow,
  Text,
} from '~/design-system';
import { Trans } from '@lingui/macro';
import Moment from 'moment';
import ImportTypeLabel from '../ImportTypeLabel';

export default function FailedImportRow({ oneImport, onDelete }) {
  return (
    <TableRow>
      <TableCell
        sx={{
          height: 65,
          width: 260,
        }}
      >
        <Text>{oneImport.name}</Text>
        <ImportTypeLabel type={oneImport.type} />
      </TableCell>
      <TableCell sx={{ height: 65, width: 240 }}>
        <Text variant="small">{oneImport.creator?.fullName}</Text>
        <Text variant="smallest">{oneImport.creator?.email}</Text>
      </TableCell>
      <TableCell sx={{ height: 65, width: 180 }}>
        <Text>{Moment(oneImport.createdAt).format('LL')}</Text>
        <Text variant="smallest">
          {Moment(oneImport.createdAt).format('LT')}
        </Text>
      </TableCell>
      <TableCell sx={{ height: 65 }}>
        <Menu>
          <MenuButton variant="icon">
            <Box
              sx={{
                border: '1px solid #ccc',
                borderRadius: 3,
                paddingY: 0,
                paddingX: 2,
              }}
            >
              ···
            </Box>
          </MenuButton>
          <MenuList
            sx={{
              zIndex: 2,
              position: 'relative',
            }}
          >
            <MenuLink href={oneImport.source.url}>
              <DownloadIcon sx={{ marginRight: 2, marginTop: -1 }} />
              <Trans>Download source file</Trans>
            </MenuLink>
            <MenuItem
              onSelect={() => onDelete(oneImport)}
              sx={{ color: 'brand.warningRed' }}
            >
              <DeleteIcon
                sx={{ marginRight: 2, marginLeft: 1, marginTop: -1 }}
              />
              <Trans>Delete</Trans>
            </MenuItem>
          </MenuList>
        </Menu>
        {oneImport.outputUrl && (
          <Link
            target="_blank"
            href={oneImport.outputUrl}
            sx={{ marginLeft: 2 }}
          >
            <Trans>Download report</Trans>
          </Link>
        )}
      </TableCell>
    </TableRow>
  );
}
